// src/components/LoadingState.js

import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

function LoadingState({ message = 'Loading...', minHeight = 200, children }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        width: '100%',
        minHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
        textAlign: 'center',
      }}
    >
      <CircularProgress sx={{ color: 'primary.main', '& circle': { strokeLinecap: 'round' } }} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
      {children && (
        <Box sx={{ width: '100%', mt: 2 }}>
          {children}
        </Box>
      )}
    </Box>
  );
}

export default LoadingState;
